export default "__VITE_ASSET__Cycibsmu__"